<template>
  <div class="bigscreen-sales">
    <div class="bigscreen-sales__header">
      <!-- 头部 -->
      <SalesHeader />
    </div>
    <div class="bigscreen-sales__body">
      <!-- 统计部分 -->
      <Auotsrceen />
      <Statistics />
      <!-- 下半部分 左 中 右结构 -->
      <div class="vocational">
        <!-- 业务结单统计 -->
        <div class="vocational-left">
          <ShippingShipParts class="con-box" />
        </div>
        <div class="vocational-center m-l-16">
          <!-- 近13个月业务数量统计 -->
          <!-- <Proplan class="con-box top" /> -->
          <!-- <component :is="showkind === 'dept' ? Deptparts : Proplan" class="con-box top" />      -->
          <!-- 今日出货计划表 -->
          <!-- <ShippingSchedule class="con-box bottom" /> -->
          <Deptparts v-if="showkind === 'dept'" class="con-box top" />
          <Proplan v-else class="con-box top" />
        </div>
        <!-- <V-IF="DPPER==1"> -->
        <div class="vocational-right m-l-16"  v-if="DPPER==1"> 
          <!-- 品质异常统计 -->
          <!-- <Unusual class="con-box bottom" /> -->
          <Unusual class="con-box" style="height: 35%; margin-bottom: 16px;" />
           <!-- 部门未完成工时统计 -->
          <!-- <div style="height: 5px;"></div>
            <Mansort class="con-box top" />           -->
            <Mansort class="con-box" style="height: 65%;" />    
        </div>
       <!-- </V-IF> -->
      </div>
    </div>
    <div class="bigscreen-sales__bottom" >
    </div>
  </div>
</template>

<script>
import SalesHeader from './components/SalesHeader.vue'
import Statistics from './components/Statistics.vue'
import ShippingShipParts from '../bigscreenSales/components/ShippingShipParts.vue';
// import ReceivingOrders from './components/ReceivingOrders.vue'
import Proplan from './components/Proplan.vue'

import Quantity from './components/Quantity.vue'
// import ShippingSchedule from './components/ShippingSchedule.vue'
// import ShippingSchedule from '../bigscreenSales/components/ShippingSchedule.vue'

// import ManHour from './components/ManHour.vue'
import Unusual from './components/Unusual.vue'
import Mansort from './components/Mansort.vue'
import Deptparts from './components/Deptparts.vue'
import Auotsrceen from './components/Auotsrceen.vue'
// import { TTS } from 'nativescript-texttospeech';

export default {
  name: 'index',
  data () {
    return {
      isFullscreen:false,
      showkind:"dept",
      text:"公告",
      deptarr:[],
      deptindex:0,   
      deptRotationInterval: null  ,
      DPPER:1

    }
  },
  components: {
    SalesHeader,
    Statistics,
    Proplan,
    Quantity,
    Deptparts,
    // ShippingSchedule,
    Mansort,
    Unusual,
    ShippingShipParts,
    Auotsrceen
  },
  watch: {},
  mounted () {
    document.documentElement.webkitRequestFullScreen()
    this.checkFull();
    window.addEventListener('dblclick',this.handleFullScreen);
    window.addEventListener('keyup',this.handleKeyup);
    const that = this
    window.onresize = () => {
        return (() => {
          that.checkFull();
        })()
    }
  },
  methods: {
    // 判断全屏
    checkFull() {
      let winFlag = window.innerHeight === window.screen.height
      let isFull = window.fullScreen || document.webkitIsFullScreen

      if (isFull === undefined) {
        this.isFullscreen = winFlag
      } else {
        this.isFullscreen = winFlag || isFull
      }
    },
    handleFullScreen(){
      let element = document.documentElement;
      if(this.isFullscreen)
      {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
        this.isFullscreen = false;
      }else{
        if (element.requestFullscreen) {
            element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
            element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
            // IE11
            element.msRequestFullscreen();
        }
         this.isFullscreen = true;
      }
    },
    handleKeyup(event){
      const e = event || window.event || arguments.callee.caller.arguments[0]
      if(!e)
      {
        return;
      }
      if(e.keyCode == 66 || e.keyCode == 13)
      {
        this.handleFullScreen();
      }
    },
    screenwake(){

      //getWindow().setFlags(WindowManager.LayoutParams.FLAG_KEEP_SCREEN_ON, WindowManager.LayoutParams.FLAG_KEEP_SCREEN_ON);
        //   navigator.wakeLock.request('screen').then(function(wakeLock) {
        // console.log('唤醒锁已获取');
        // 在这里进行你想做的事情
        // ...
        // 然后在完成后释放唤醒锁
        // wakeLock.release();
        // console.log('唤醒锁已释放');
      // });
    },
    startDeptRotation() {     
      this.stopDeptRotation();
      this.deptRotationInterval = setInterval(() => {
        this.deptindex = (this.deptindex + 1) % this.deptarr.length;
        window.localStorage.setItem('bsmdept', this.deptarr[this.deptindex]);
        console.log('Rotated department to:', this.deptarr[this.deptindex]);
      }, 10 * 60 * 1000); // 10 minutes in milliseconds
    },
    stopDeptRotation() {
      if (this.deptRotationInterval) {
        clearInterval(this.deptRotationInterval);
        this.deptRotationInterval = null;
        console.log('Department rotation stopped');
      }
    },
    initDeptSystem() {
      var bb = window.localStorage.getItem('bsmSweetDept');
      var dpt = window.localStorage.getItem('bsmdept');
      var ispro = window.localStorage.getItem('bsmisprodep');

      if (ispro == 1) {
        bb = dpt + ";" + bb;
      }

      bb = bb.trim();
      if (bb.length > 0) {
        this.deptarr = bb.split(";");
        this.deptindex = 0;
        window.localStorage.setItem('bsmdept', this.deptarr[this.deptindex]);
        this.startDeptRotation();
      }
    }
  },
  created () {
    // this.screenwake();
    var aa =window.localStorage.getItem('bsmshowdept')
    var cc =window.localStorage.getItem('bsmpowerstr')||""
    this.DPPER = cc.includes("DPPER0") ? 0 : 1;   
    // console.log('bsmshowdept',aa)
    if(aa==="1")
      this.showkind="dept"
    else
      this.showkind=""
    this.initDeptSystem();

     


  },
  beforeDestroy() {
    this.stopDeptRotation();
    window.removeEventListener('dblclick', this.handleFullScreen);
    window.removeEventListener('keyup', this.handleKeyup);
    window.onresize = null;
  },
}
// background-image: url('../../assets/images/bigscreenSales/bottom.png');
</script>

<style scoped lang="less">
  .bigscreen-sales {
    width: 100%;
    height: 100vh;
    padding-top: 4px;
    box-sizing: border-box;
    background: #010916;
    display: flex;
    flex-direction: column;

    &__header {
      width: 100%;
      height: 74px;
      background: linear-gradient(270deg,
          #060c16 0%,
          rgba(9, 28, 45, 0.9) 50.06%,
          #11182d 101.04%);
    }

    &__body {
      margin-top: 4px;
      flex: 1;
      min-height: 0;
      padding: 0 24px;
      display: flex;
      flex-direction: column;

      .vocational {
        flex: 1;
        min-height: 0;
        margin-top: 10px;
        display: flex;

        .con-box {
          background: rgba(10, 36, 62, 0.6);
          border-radius: 8px;
          padding: 16px;
          box-sizing: border-box;
        }

        .vocational-left {
          width: 425px;
          height: 100%;
        }

        .vocational-center,
        .vocational-right {
          display: flex;
          flex-direction: column;
          height: 100%;

          .top {
            flex: 1;
            margin-bottom: 16px;
          }

          .bottom {
            min-height: 0;
            height: 56%;
          }
        }

        .vocational-center {
          // width: 991px;
          flex-grow: 2;
        }

        .vocational-right {
          width: 424px;
        }
      }
    }

    &__bottom {
      width: 100%;
      height: 60px;
       background-image: url('http://47.107.138.238/img/bottom.aaf8d41.png');
      background-size: 100% 100%;
      background-repeat: no-repeat;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/workroomdp/index.vue